import { BatteryRechargingCapacity } from '@/models';

export interface BatteryRechargingCapacityState {
  batteryResult: BatteryRechargingCapacity[] | null
}

export const InitialState: BatteryRechargingCapacityState = {
  batteryResult: null
}
